import * as React from "react";
import type { SVGProps } from "react";
const SvgRotateCw = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M24 4a1 1 0 1 0-2 0zm-1 6v1a1 1 0 0 0 1-1zm-6-1a1 1 0 1 0 0 2zm4.433 6.333a1 1 0 1 0-1.886-.666zM18.37 5.64l-.707.707.021.021zM22 4v6h2V4zm1 5h-6v2h6zm-3.453 5.667a8 8 0 0 1-3.116 3.999l1.107 1.665a10 10 0 0 0 3.895-4.998zm-3.116 3.999a8 8 0 0 1-4.894 1.322l-.117 1.997a10 10 0 0 0 6.118-1.654zm-4.894 1.322a8 8 0 0 1-4.707-1.884l-1.293 1.525a10 10 0 0 0 5.883 2.356zM6.83 18.104a8 8 0 0 1-2.628-4.335l-1.95.442a10 10 0 0 0 3.285 5.418zm-2.628-4.335a8 8 0 0 1 .504-5.044l-1.824-.82a10 10 0 0 0-.63 6.306zm.504-5.044a8 8 0 0 1 3.435-3.729l-.965-1.751a10 10 0 0 0-4.294 4.66zm3.435-3.729a8 8 0 0 1 4.986-.915l.281-1.98a10 10 0 0 0-6.232 1.144zm4.986-.915a8 8 0 0 1 4.536 2.266l1.414-1.414a10 10 0 0 0-5.669-2.832zm4.557 2.287 4.63 4.36 1.372-1.456-4.63-4.36z"
    />
  </svg>
);
export default SvgRotateCw;
